import { Col, Container, Row } from 'react-bootstrap'
import { IntegrationServiceId } from '../../common/integrations'
import { useAppDispatch } from '../../store/hooks'
import { addToast } from '../../store/toast/toastSlice'
import { AccountAwareIntegrationIcon } from '../AccountAwareIntegrationIcon'
import { Button } from '../Button/Button'
import { ZoomOBFWarningRow } from '../ZoomOBFWarning/ZoomOBFWarningRow'

export const EmailIntegrationTool = () => {
  const dispatch = useAppDispatch()

  const handleCopyAssistantClicked = () => {
    navigator.clipboard.writeText(`assistant@invite.zocks.io`)
    dispatch(
      addToast({
        variant: 'info',
        title: 'Copied',
        messages: ['assistant@invite.zocks.io Copied to your Clipboard!'],
      }),
    )
  }
  return (
    <Container className='d-flex flex-column gap-4 justify-content-between h-100 p-0'>
      <Row>
        <Col xs='auto' className='gx-3'>
          <div className='flex rounded integration-icon-wrapper'>
            <i className='bi bi-robot '></i>
          </div>
        </Col>
        <Col>
          <h5>Invite your AI assistant to your meetings</h5>
          <div className='paragraph-medium zocks-text-gray-600'>
            Add <span className='email-integration-email'>assistant@invite.zocks.io</span> to your meeting events so that Zocks will automatically join your
            scheduled meetings.
          </div>
        </Col>
      </Row>
      <ZoomOBFWarningRow />
      <Row>
        <Container className='upcoming-integration-bottom-box'>
          <Row className='align-items-center'>
            <Col>
              <div className='paragraph-small zocks-text-gray-600'>It works on</div>
            </Col>

            <Col xs='auto' className='flex align-items-center justify-content-end'>
              <AccountAwareIntegrationIcon serviceId={IntegrationServiceId.ZOOM} width='2rem' height='2rem' className='me-1' />
              <AccountAwareIntegrationIcon serviceId={IntegrationServiceId.TEAMS} width='2rem' height='2rem' className='me-1' />
              <AccountAwareIntegrationIcon serviceId={IntegrationServiceId.MEET} width='2rem' height='2rem' className='me-1' />
              <AccountAwareIntegrationIcon serviceId={IntegrationServiceId.WEBEX} width='2rem' height='2rem' className='me-1' />
            </Col>
          </Row>
          <Row className='d-flex align-items-center m-0'>
            <Col className='d-flex justify-content-end p-0'>
              <Button variant='primary' onClick={handleCopyAssistantClicked} className='w-100 px-0'>
                Copy Email to Clipboard
              </Button>
            </Col>
          </Row>
        </Container>
      </Row>
    </Container>
  )
}
